'use client';

import { c as _c } from "react/compiler-runtime";
import iconsSVG from '@images/svg/IconsSVG.svg';
const SVGelem = t0 => {
  const $ = _c(11);
  const {
    className,
    href,
    handleClick
  } = t0;
  let t1;
  if ($[0] !== className || $[1] !== handleClick || $[2] !== href) {
    t1 = iconsSVG && handleClick && <svg onClick={handleClick} className={className}><use href={iconsSVG.src + `${href}`} /></svg>;
    $[0] = className;
    $[1] = handleClick;
    $[2] = href;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== className || $[5] !== handleClick || $[6] !== href) {
    t2 = iconsSVG && !handleClick && <svg className={className}><use href={iconsSVG.src + `${href}`} /></svg>;
    $[4] = className;
    $[5] = handleClick;
    $[6] = href;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== t1 || $[9] !== t2) {
    t3 = <>{t1}{t2}</>;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
};
export default SVGelem;